module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image03-26b3e8520db1fb7426652f46652b8b67.png";